import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
/**
 * Empty state (handoff, Molecules and UX principle 6): propose the next
 * action and explain the payoff. Left-aligned on the canvas it sits in, with
 * no box around it, so it reads as a prompt rather than as an error — and so
 * it never becomes a box inside the section box it belongs to.
 *
 * "Create your first practice", never "No practices found."
 */
export function EmptyState({ title, description, action, variant, headingLevel = variant === 'section' ? 3 : 2, className, }) {
    const Heading = `h${headingLevel}`;
    return (_jsxs("div", { className: cn('flex min-w-0 flex-col items-start', variant === 'page' && 'gap-4 py-8', variant === 'section' && 'gap-2 py-4', className), children: [_jsx(Heading, { className: cn('max-w-measure-max text-text text-balance wrap-anywhere', variant === 'section' ? 'text-h4 font-semibold' : 'text-h2 font-bold'), children: title }), _jsx("p", { className: "max-w-measure-max text-body text-text-secondary text-pretty wrap-anywhere", children: description }), action] }));
}
//# sourceMappingURL=EmptyState.js.map